// extracted by mini-css-extract-plugin
module.exports = {"on":"styles_on__3V-pR","off":"styles_off__1rVId","switchState":"styles_switchState__6aNKL","weekContainer":"styles_weekContainer__1fmE9"};